export const CATALOG_PROVIDER_KEYS = [
    "purview",
    "unityCatalog",
    "collibra",
    "alation",
    "informatica",
];
export const CATALOG_AUTH_MODELS = ["servicePrincipal", "oauthRefreshToken", "apiToken"];
export const CATALOG_SURFACE_KEYS = [
    "technicalMetadata",
    "businessGlossary",
    "lineage",
    "governance",
];
export const CATALOG_SEARCH_SURFACE_KEYS = ["technicalMetadata", "businessGlossary"];
export const CATALOG_CONNECTION_STATUSES = [
    "draft",
    "connected",
    "degraded",
    "reauthRequired",
    "validationFailed",
    "disconnected",
];
export const CATALOG_SYNC_MODES = ["snapshot", "incremental"];
export const CATALOG_SYNC_TRIGGER_KINDS = ["manual", "scheduled", "webhook", "revalidate"];
export const CATALOG_SYNC_STATUSES = [
    "pending",
    "running",
    "succeeded",
    "truncated",
    "failedRetryable",
    "failedTerminal",
    "paused",
];
export const CATALOG_PROVIDER_MANIFESTS = [
    {
        providerKey: "purview",
        displayName: "Microsoft Purview",
        connectorMode: "builtin",
        defaultAuthModel: "servicePrincipal",
        authModels: ["servicePrincipal"],
        surfaces: ["technicalMetadata", "businessGlossary", "lineage", "governance"],
        capabilities: {
            reference: true,
            bulkSync: true,
            webhook: true,
            workflowAware: true,
        },
        providerExtensionSchemaVersion: 1,
        rateLimitProfile: {
            basis: "requests",
            burstLimit: 20,
            sustainedLimit: 600,
            windowSeconds: 60,
            concurrencyCap: 2,
            retryAfterHeader: "Retry-After",
        },
        notes: "Reference connector for v1. Dual-surface support spans technical assets and glossary terms.",
    },
    {
        providerKey: "unityCatalog",
        displayName: "Databricks Unity Catalog",
        connectorMode: "builtin",
        defaultAuthModel: "servicePrincipal",
        authModels: ["servicePrincipal", "apiToken"],
        surfaces: ["technicalMetadata", "businessGlossary", "lineage"],
        capabilities: {
            reference: true,
            bulkSync: true,
            webhook: false,
            workflowAware: false,
        },
        providerExtensionSchemaVersion: 1,
        rateLimitProfile: {
            basis: "requests",
            burstLimit: 30,
            sustainedLimit: 900,
            windowSeconds: 60,
            concurrencyCap: 3,
        },
        notes: "Strong technical metadata baseline for browse, search, and rich-text embeds.",
    },
    {
        providerKey: "collibra",
        displayName: "Collibra",
        connectorMode: "builtin",
        defaultAuthModel: "apiToken",
        authModels: ["apiToken", "oauthRefreshToken"],
        surfaces: ["technicalMetadata", "businessGlossary", "lineage", "governance"],
        capabilities: {
            reference: true,
            bulkSync: true,
            webhook: false,
            workflowAware: true,
        },
        providerExtensionSchemaVersion: 1,
        rateLimitProfile: {
            basis: "requests",
            burstLimit: 15,
            sustainedLimit: 450,
            windowSeconds: 60,
            concurrencyCap: 2,
            retryAfterHeader: "Retry-After",
        },
        notes: "Governance-heavy provider with workflow-sensitive publication semantics.",
    },
    {
        providerKey: "alation",
        displayName: "Alation",
        connectorMode: "builtin",
        defaultAuthModel: "apiToken",
        authModels: ["apiToken"],
        surfaces: ["technicalMetadata", "businessGlossary", "lineage"],
        capabilities: {
            reference: true,
            bulkSync: true,
            webhook: false,
            workflowAware: false,
        },
        providerExtensionSchemaVersion: 1,
        rateLimitProfile: {
            basis: "requests",
            burstLimit: 12,
            sustainedLimit: 360,
            windowSeconds: 60,
            concurrencyCap: 2,
        },
        notes: "Overlay-oriented provider for metadata discovery and reference workflows.",
    },
    {
        providerKey: "informatica",
        displayName: "Informatica",
        connectorMode: "builtin",
        defaultAuthModel: "oauthRefreshToken",
        authModels: ["oauthRefreshToken", "apiToken"],
        surfaces: ["technicalMetadata", "businessGlossary", "lineage", "governance"],
        capabilities: {
            reference: true,
            bulkSync: true,
            webhook: false,
            workflowAware: true,
        },
        providerExtensionSchemaVersion: 1,
        rateLimitProfile: {
            basis: "jobs",
            burstLimit: 8,
            sustainedLimit: 120,
            windowSeconds: 60,
            concurrencyCap: 1,
        },
        notes: "Enterprise metadata provider modeled for browse and embed workflows.",
    },
];
export const CATALOG_PROVIDER_MANIFESTS_BY_KEY = CATALOG_PROVIDER_MANIFESTS.reduce((accumulator, manifest) => {
    accumulator[manifest.providerKey] = manifest;
    return accumulator;
}, {
    purview: CATALOG_PROVIDER_MANIFESTS[0],
    unityCatalog: CATALOG_PROVIDER_MANIFESTS[1],
    collibra: CATALOG_PROVIDER_MANIFESTS[2],
    alation: CATALOG_PROVIDER_MANIFESTS[3],
    informatica: CATALOG_PROVIDER_MANIFESTS[4],
});
export function getCatalogProviderManifest(providerKey) {
    return CATALOG_PROVIDER_MANIFESTS_BY_KEY[providerKey];
}
